<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Confirm actions"
    @close="onCloseModal">
    <div v-if="computedIsClosed">
      Are you sure you want to reactivate this issue?
    </div>
    <div v-else>
      Are you sure you want to deactivate this issue?
    </div>
    <template #modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :icon="!computedIsClosed ? dataIconBan : dataIconCheck"
        type="danger"
        @click="clickBlocked()">
        {{ computedIsClosed ? 'Reactivate' : 'Deactivate' }}
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import CallButton from '../CallButton';
import iconsModal from '../../../mixins/iconsModal';
import { ISSUES_UPDATE } from '@/store/types/actions.types';
import { faBan, faCheck } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CallIssuesActiveDeactivate',
  components: {
    CallButton,
    BModal
  },
  mixins: [iconsModal],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    objIssues: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataIconCheck: faCheck,
      dataIconBan: faBan,
      dataModal: this.value
    };
  },
  computed: {
    computedIsClosed () {
      return !!this.objIssues.is_closed;
    }
  },
  watch: {
    value () {
      this.dataModal = this.value;
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('input', false);
    },
    async clickBlocked () {
      const isClosed = !this.computedIsClosed;

      try {
        await this.$store.dispatch(`issues/${ISSUES_UPDATE}`, {
          id: this.objIssues.id,
          params: {
            name: this.objIssues.name,
            category_id: this.objIssues.category_id,
            team_ids: (this.objIssues.teams || []).map(({ id }) => id),
            description: this.objIssues.description,
            is_closed: isClosed
          },
          context: this
        });

        this.$emit('on-update');
        this.$Notify({
          title: 'Issues',
          message: `Issue successfully ${isClosed ? 'deactivated' : 'reactivated'}`,
          type: 'success'
        });
        this.onCloseModal();
      } catch (e) {
        this.$Notify({
          title: 'Issues',
          message: 'Failed to update issue',
          type: 'error'
        });
      }
    }
  }
};
</script>
